/*
 * @Author: lidan
 * @Date: 2020-11-13 10:18:31
 * @LastEditTime: 2020-11-19 15:00:35
 * @LastEditors: lidan
 * @Description: 运单应付费用api
 * @FilePath: \e6-module-settle-accounts-center\src\e6-module-settle-accounts-center\api\waybillPayable.js
 */
import http from "e6-base-core/axios/config";
import { e6ModuleSettleAccountsCenterApi } from "@/config/api";
const {
  host = "",
  E6_MS_TMS_FINANCIAL_WEB = ""
} = e6ModuleSettleAccountsCenterApi;

// 获取运单应付费用表格数据
export function waybillReportPayable(data) {
  return http({
    url: `${host}${E6_MS_TMS_FINANCIAL_WEB}/waybillReport/payable`,
    method: "post",
    data
  });
}

// 导出运单应付费用
export function exportWaybillPayable(data) {
  return http({
    headers: { "Content-Type": "application/json" },
    responseType: "blob",
    url: `${host}${E6_MS_TMS_FINANCIAL_WEB}/waybillReport/export/payable`,
    method: "post",
    data
  });
}
